import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FirstErrorPipe } from '@fuse/pipes/first-error/first-error.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FcDataCardV2Component } from './fc-data-card-v2.component';


@NgModule({
  entryComponents: [
    FcDataCardV2Component
  ],
  declarations: [
    FcDataCardV2Component
  ],
  imports: [
    CommonModule,
    MatIconModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    FcDataCardV2Component
  ],
  providers: [
    FirstErrorPipe
  ]
})
export class FcDataCardV2Module {}
